import styled from '@emotion/styled';

import { mq } from '@/utility/mediaQuery';
import { defaultTheme } from '@/utility/theme';
import { hoverOpacity } from '@/utility/theme/animation';

export const Container = styled.div(() =>
  mq({
    width: '100%',
    backgroundColor: defaultTheme.background.white,
    padding: [
      defaultTheme.spacing.l,
      defaultTheme.spacing.l,
      defaultTheme.spacing.xxl,
      defaultTheme.spacing.xxl,
    ],
    textAlign: 'center',
  }),
);

export const Text = styled.p(() =>
  mq({
    fontSize: defaultTheme.font.size.s,
    margin: `${defaultTheme.spacing.l} 0 ${defaultTheme.spacing.xxl}`,
  }),
);

export const TextLink = styled.a(() =>
  mq({
    textDecorationLine: 'underline',
    ...hoverOpacity,
  }),
);
